// utils
import { generateRandomCode } from 'app/utils';

function formatEquipmentCallback(equipmentReportProblem) {
  const { equipmentId, problemClassification, quantity, description, formAddOn } =
    equipmentReportProblem;

  const randomCode = formAddOn.randomCode ? formAddOn.randomCode : generateRandomCode();
  return {
    equipmentId,
    problemClassification,
    quantity,
    description,
    formAddOn: {
      ...formAddOn,
      hasError: false,
      randomCode
    }
  };
}

export { formatEquipmentCallback };
